"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
function StartingHint(props) {
    const { className } = props;
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'StartingHint_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'StartingHint_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.classroom.startHintTitle) }), (0, jsx_runtime_1.jsx)(Subtitle, { "data-e2e": 'StartingHint_Subtitle', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.classroom.startHintSubtitle) })] }));
}
exports.default = StartingHint;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 10px;
  right: 10px;

  display: flex;
  flex-direction: column;

  width: 150px;
  padding: 10px;

  color: ${props => props.theme.white};

  background-color: ${props => props.theme.black_50};
  border-radius: 2px;

  cursor: pointer;

  pointer-events: auto;
`;
const Title = styled_components_1.default.div `
  margin: auto 0 5px 0;

  color: ${props => props.theme.white};
  font-weight: bold;
  font-size: 11px;
  text-align: left;
`;
const Subtitle = styled_components_1.default.div `
  margin: 0 0 auto 0;

  color: ${props => props.theme.white};
  font-size: 11px;
  text-align: left;
`;
